exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.roi-switch.md-theme-default.md-checked.md-primary .md-switch-container {\n  background-color: #FFFFFF;\n  border: 1px solid rgba(0, 194, 176, 0.5);\n}\n.roi-switch.md-theme-default.md-checked.md-primary .md-switch-container .md-switch-thumb {\n    background: #00C2B0;\n}\n.roi-switch.md-theme-default .md-switch-container {\n  width: 35px;\n  height: 20px;\n  background-color: #FFFFFF;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-radius: 30px;\n}\n.roi-switch.md-theme-default .md-switch-container .md-switch-thumb {\n    background: #E5E5E5;\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    width: 20px;\n    height: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91198992","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/settings/security/Security.TfaSettings.vue
// module id = +ZYg
// module chunks = 1